import React from 'react'

const Subcategory = () => {
  return (
    <div>Subcategory</div>
  )
}

export default Subcategory